/*
 * @Descripttion: $0
 * @version: 
 * @Author: linPing
 * @Date: 2020-07-18 15:33:29
 * @LastEditTime: 2020-07-23 14:03:40
 */
import Cookies from 'js-cookie'
import CryptoJS from "crypto-js";

const key='labvision2023'
const Authorization = 'token'
const tokenTime = 600000 //token过期时间

export function retrieveToken () {
  let token = Cookies.get(Authorization);
  if(token) {
    const decrypted = CryptoJS.DES.decrypt(token, CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    })
    token=decrypted.toString(CryptoJS.enc.Utf8)
  } else {
    token = ''
  }
  return token
}

export function storeToken (token) {
  const encrypt = CryptoJS.DES.encrypt(token, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  let dest = encrypt.toString();
  return Cookies.set(Authorization, dest, { expires: new Date(new Date().getTime() + tokenTime * 1000) })
}

export function deleteToken () {
  // return Cookies.remove(Authorization)
}

export function decryptDataByToken(data) {
  console.log('decryptDataByToken 111: data', data)
  let keyStr = retrieveToken()
  if(keyStr===null || keyStr===undefined || keyStr==='') {
    return data
  }

  // console.log('decryptDataByToken 222: keyStr', keyStr)
  const decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(keyStr.substring(0,16)), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  // console.log('decryptDataByToken 333: decrypted', decrypted)
  let _data = CryptoJS.enc.Utf8.stringify(decrypted).toString(CryptoJS.enc.Utf8)
  console.log('decryptDataByToken 444: _data', _data)
  return _data
}

